<!--
 * @FileDescription: 文件上传一个通用的模板（注释描述）
 * @Author:xy（作者）
 * @Date: 2020-07-02（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-15（最后更新时间）
 -->
<template>
    <div>
        <div class="upload-file" v-if="fileobj.length > 0">
            <div class="upload-content">
                <div class="upload-img-list">
                    <div class="upload-imgs" v-for="(item,index) in fileobj" :key="index">
                        <img :src="item.resourceUrl" alt="">
                        <div class="upload-imgs-hover">
                            <div class="insert">
                                <div class="insert-item">插入图片
                                    <input type="file"
                                        ref="thumbnail1"
                                        id="input4"
                                        multiple="multiple"
                                        @change="doUpload(2,item,index)" />
                                </div>
                                <div class="insert-item">替换图片
                                    <input type="file"
                                        ref="thumbnail2"
                                        id="input3"
                                        @change="doUpload(3,item,index)" />
                                </div>
                                <div class="insert-item"  @click=onDelete(item,index)>删除</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="upload-img">
                <input type="file"
                    ref="thumbnail"
                    id="input2"
                    multiple="multiple"
                    @change="doUpload(1)" />
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="upload-title">上传图片</div>
            </div>
        </div>
        <div class="upload" v-else>
            <input type="file"
                    ref="thumbnail"
                    id="input1"
                    multiple="multiple"
                    @change="doUpload(1)" />
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="upload-title">上传图片</div>
        </div>
    </div>
</template>
<script>
    import {uploadMultiFile,uploadFile} from "@/utils/api";
export default {
  data () {
    return {
        fileobj:[],
        loading:false,
    }
  },
  props: {
    width:{
        type:Number,
        default:120
    },
    height:{
        type:Number,
        default:36
    },

  },
  watch(){

  },
  methods: {
    onOpen(value){
        if(value.length > 0){
            this.fileobj = []
            value.forEach((item)=>{
                this.fileobj.push(item)
            })
            console.log(this.fileobj)
        }else{
            this.fileobj = []
        }
        console.log(this.fileobj)
    },
    doUpload (tabindex,item,itemIndex) {
        let imageFile = ''
        if(tabindex == 1){
            imageFile = this.$refs.thumbnail.files
        }else if(tabindex == 2){
            imageFile = this.$refs.thumbnail1[itemIndex].files
        }else if(tabindex == 3){
            imageFile = this.$refs.thumbnail2[itemIndex].files
        }
        var form = new FormData()
        if (imageFile.length > 0) {
            for(let i = 0;i<imageFile.length;i++){
                if(imageFile[i].size > 1024*1024 ){
                    this.$message.warn('文件过大')
                }else{
                    form.append("file",imageFile[i])
                }
            }
            form.append("type","store")
            uploadMultiFile(form,{
                'Content-Type':'multipart/form-data'
            }).then((res)=>{
                $('#input1').val('')
                $('#input2').val('')
                $('#input3').val('')
                $('#input4').val('')
                if(res.success){
                        this.$message.success(res.logMessage)
                        res.result.forEach((item)=>{
                            item.resourceUrl = item.resource_url
                            item.resourceId = item.id
                        })
                    if(tabindex == 1){
                        res.result.forEach((item)=>{
                            this.fileobj.push(item)
                        })
                    }else if(tabindex == 2){
                        res.result.forEach((resitem,index)=>{
                            this.fileobj.splice(itemIndex+1+index,0,res.result[index])
                        })
                    }else if(tabindex == 3){
                        this.fileobj.splice(itemIndex,1,res.result[0])
                    }
                    this.$emit('onChangeImg',this.fileobj)
                }else{
                    this.$message.warn(res.logMessage)
                    if(res.result.length > 0){
                        res.result.forEach((item)=>{
                            if(item.success == 'true'){
                                if(tabindex == 1){
                                    this.fileobj = res.result
                                }else if(tabindex == 2){
                                    res.result.forEach((resitem,index)=>{
                                        this.fileobj.splice(itemIndex+1+index,0,res.result[index])
                                    })
                                }else if(tabindex == 3){
                                    this.fileobj.splice(itemIndex,1,res.result[0])
                                }
                            }
                        })
                    }
                    this.$emit('onChangeImg',this.fileobj)
                }
            })
        }
    },
    onDelete(item,index){
        this.$comm.removeByIndex(this.fileobj,index)
        this.$emit('onChangeImg',this.fileobj)
    }
  }
}
</script>
<style lang="scss">

</style>
<style lang="scss">
    .upload{
        width: 1012px;
        height: 80px;
        background: #fafafa;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        input {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            filter: alpha(opacity=0);
            cursor: pointer;
            width: 100%;
            height: 100%;
        }
        .anticon{
            svg{
                font-size: 30px;
                color: #aaa;
                font-weight: 700;
            }
        }
        .upload-title{
            color: #aaa;
            font-size: 14px;

        }

    }
    .upload-file{
        width: 1012px;
        height: 547px;
        background: #aaa;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        .upload-content{
            width: 375px;
            height: 547px;
            overflow-y: auto;
            position: relative;
            padding-bottom: 48px;
            background: #ccc;
            .upload-img-list{
                display: flex;
                flex-direction: column;
                .upload-imgs{
                    width: 375px;
                    position: relative;
                    img{
                        width: 375px;
                        object-fit: cover; 
                    }
                    .upload-imgs-hover{
                        display: none;
                        position: absolute;   
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0,0,0,0.4);  
                        .insert{
                            position: absolute;
                            top: 10px;
                            left: 10px;
                            width: 225px;
                            height: 32px;
                            background: #fff;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .insert-item{
                                padding: 0 10px;
                                border-right: 1px solid #858585;
                                line-height: 12px;
                                cursor: pointer;
                                position: relative;
                                input{
                                    position: absolute;
                                    left: 0;
                                    top: 0;
                                    opacity: 0;
                                    filter: alpha(opacity=0);
                                    cursor: pointer;
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .insert-item:last-child{
                                border-right: none;
                            }
                        }
                    }
                }
                .upload-imgs:hover .upload-imgs-hover{
                    display: block;
                }
            }
        }
         .upload-img{
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 375px;
            height: 48px;
            background: #fafafa;
            display: flex;
            align-items: center;
            justify-content: center;
            input {
                position: absolute;
                left: 0;
                top: 0;
                opacity: 0;
                filter: alpha(opacity=0);
                cursor: pointer;
                width: 100%;
                height: 100%;
            }
            .anticon{
                svg{
                    font-size: 14px;
                    color: #aaa;
                    margin-right: 10px;
                    font-weight: 700;
                }
            }
            .upload-title{
                color: #aaa;
                font-size: 14px;

            }
        }
    }
</style>
